<template>
  <div class="reportTable">
    <section ref="print">
      <div class="mytitle">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>{{ this.$moment(this.startDate).format("YYYY-MM-DD") }}</span>
            <span
              v-if="$parent.endTimeShow"
            >至{{ this.$moment(this.endDate).format("YYYY-MM-DD") }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: flex-end">
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
          </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div style="width: 100%; height: 100%">
        <div class="form-content">
          <div class="formTitle">
            <!-- <span style="width: 2em"></span> -->
            <span>账号</span>
            <span>房号</span>
            <span>宾客名称</span>
            <span style="text-align:right">预授金额</span>
            <span style="text-align:right">实际扣除金额</span>
                  <span>状态</span>
            <span>酒店日期</span>
            <span style="flex:2">操作时间</span>
            <span>操作员</span>
      
          </div>
        </div>
        <div class="formContaniner">
          <transition-group name="preArrivalList" tag="p">
            <div class v-for="(item, index) in preArrivalList" v-bind:key="index">
              <div
                class="PreArrivalItem"
                v-for="(item2, index2) in item.largessList"
                v-bind:key="index2"
              >
                <!-- <div style="width: 2em">{{ index2 + 1 }}</div> -->
                <div>{{item.accNo}}</div>
                <div>{{item.roomNo}}</div>
                <div>{{item.guestName}}</div>

                <div style="text-align:right">{{$parent.curreny(item2.amount)}}</div>
                <div style="text-align:right">{{$parent.curreny(item2.actualAmount)}}</div>
                  <div v-if="item2.status==0">成功</div>
                <div v-else-if="item2.status==1">撤销</div>
                <div v-else-if="item2.status==2">已使用</div>
                <div v-else></div>
                <div>{{item2.hotelTime}}</div>
                <div style="flex:2">{{item2.createTime}}</div>
                <div>{{item2.operator}}</div>
              
              </div>
            </div>
          </transition-group>
        </div>
        <!-- <div class="total">
          <div>
            <span style="padding-left:120px">合计:</span>
            <span>{{ record }}条记录</span>
          </div>
        </div>-->
      </div>
    </section>
  </div>
</template>

<script>
import { getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      // 本日预到的宾客表
      preArrivalList: [],
      // 记录
      record: "",
      room: "",
      total: "",
      userName: localStorage.getItem("cname"),
      allPage: 0,
      // 查询日期
      queryDate: "",
      date: "",
      // dodayin: false,
      visible: true,
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.$parent.bbmc = "F21.前台宾客预授权报表";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    //把所有搜索都隐藏
    this.$parent.closeshow();
    this.$parent.startTimeShow = true;
    this.$parent.endTimeShow = true;
    this.$parent.showZt = true;
    this.$parent.chaxunvib = true;
    this.doserach();
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print);
    },
    confirm() {
      // this.$print(this.$refs.print);
      this.close();
    },
    close() {
      this.visible = false;
      // this.dodayin = false;
    },
    dateChange(data) {
      // 
      this.date = this.$moment(data).format("YYYY-MM-DD HH:mm:ss");
    },
    doserach() {
      let loadingInstance = this.$loading({ text: "正在查询..." });
      getRequest(
        "/report/F21?startTime=" +
          this.$parent.startDate +
          "&endTime=" +
          this.$parent.endDate +
          "&status=" +
          this.$parent.zhuangtai
      ).then(res => {
        
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          let list = [];
          res.data.forEach(item => {
            item.largessList.forEach(item2 => {
              if (item2.status == 0) {
                item2.status2 = "成功";
              } else if (item2.status == 1) {
                item2.status2 = "撤销";
              } else if (item2.status == 2) {
                item2.status2 = "已使用";
              }
              item2.accNo = item.accNo;
              item2.roomNo = item.roomNo;
              item2.guestName = item.guestName;
              list.push(item2);
            });
          });
          this.$store.state.preArrivalList = list;
          this.$store.state.preArrivalName = "F21.前台宾客预授权报表";
          this.$parent.datacount = list;
          this.preArrivalList = list;
          this.record = list.length;
          this.allPage = Math.ceil(list.length / 10);
          this.preArrivalList = res.data;
          this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.mytitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px !important;
  line-height: 24px;
  margin-bottom: 1em;
}
.total > div {
  border-top: 1px solid black;
  padding-top: 5px;
  padding-left: 0;
}
.formTitle{
  display: flex;
}
.formTitle>span{
  flex:1
}
.PreArrivalItem{
  display: flex;
}
.PreArrivalItem >div{
    flex:1
}
.total > div > span {
  margin-right: 0;
}
.form-content {
  border-top: 1px solid black;
}
</style>

